import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const KNOWLEDGE_BASE = {
  initial: "Greetings. I am the Page1News concierge. How may I assist you in shaping your narrative today?",
  options: [
    { id: 'services', label: 'Our Services', response: 'We offer PR Strategy, Media Outreach, Personal Branding, Content Storytelling, and Event PR. Each service is executed with literary precision.' },
    { id: 'founder', label: 'About the Founder', response: 'Romita Khurana Sahni is an author, TEDx anchor, and recipient of the Women Achievers Award 2024. She brings a "literary soul" to PR.' },
    { id: 'contact', label: 'How to Start?', response: 'You can use our contact form below or email hello@page1news.com. We are ready to own your narrative.' }
  ]
};

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([{ type: 'bot', text: KNOWLEDGE_BASE.initial }]);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages]);

  const handleOptionClick = (option) => {
    setMessages(prev => [
      ...prev, 
      { type: 'user', text: option.label },
      { type: 'bot', text: option.response }
    ]);
  };

  return (
    <div className="fixed bottom-8 right-8 z-[60]">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="mb-6 w-[350px] bg-navy-900 border border-gold-500/30 shadow-2xl overflow-hidden flex flex-col"
          >
            {/* Header */}
            <div className="bg-navy-800 p-4 border-b border-gold-500/20 flex justify-between items-center">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 rounded-full bg-gold-500 animate-pulse"></div>
                <span className="font-serif text-white font-medium tracking-wide">Concierge</span>
              </div>
              <button onClick={() => setIsOpen(false)} className="text-gray-400 hover:text-white">
                <SafeIcon icon={FiIcons.FiMinimize2} />
              </button>
            </div>

            {/* Messages */}
            <div ref={scrollRef} className="h-80 overflow-y-auto p-4 space-y-4 scrollbar-thin scrollbar-thumb-gold-500/20">
              {messages.map((msg, idx) => (
                <div key={idx} className={`flex ${msg.type === 'user' ? 'justify-end' : 'justify-start'}`}>
                  <div className={`max-w-[80%] p-3 text-sm ${
                    msg.type === 'user' 
                      ? 'bg-gold-500 text-navy-900' 
                      : 'bg-navy-800 text-gray-200 border border-white/5'
                  }`}>
                    {msg.text}
                  </div>
                </div>
              ))}
            </div>

            {/* Options */}
            <div className="p-4 border-t border-white/5 bg-navy-900/50">
              <div className="flex flex-wrap gap-2">
                {KNOWLEDGE_BASE.options.map((opt) => (
                  <button
                    key={opt.id}
                    onClick={() => handleOptionClick(opt)}
                    className="text-xs border border-gold-500/40 text-gold-500 px-3 py-1.5 hover:bg-gold-500 hover:text-navy-900 transition-colors"
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setIsOpen(!isOpen)}
        className="w-16 h-16 bg-gold-500 text-navy-900 flex items-center justify-center shadow-xl relative"
      >
        <SafeIcon icon={isOpen ? FiIcons.FiX : FiIcons.FiMessageSquare} className="text-2xl" />
        {!isOpen && (
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-white rounded-full border-2 border-navy-900 animate-bounce"></span>
        )}
      </motion.button>
    </div>
  );
};

export default Chatbot;